export default __webpack_public_path__ + "images/referenzen/socialmedia/sport_alliance_magicline_awarenessfilm.mp4";